import { Link } from 'react-router-dom'
import { canAccessTool, useAccess, type ToolId } from '../lib/access'

function Pending() {
  return (
    <div className="flex items-center justify-center py-24">
      <div className="w-8 h-8 border-2 border-slate-300 dark:border-slate-600 border-t-blue-500 rounded-full animate-spin" />
    </div>
  )
}

function Denied({ what }: { what: string }) {
  return (
    <div className="text-center py-24">
      <div className="text-4xl mb-3">🔒</div>
      <h2 className="text-slate-900 dark:text-white text-lg font-semibold mb-1">No access to {what}</h2>
      <p className="text-slate-500 dark:text-slate-400 text-sm mb-4">
        Ask Nathanael to grant you access from the Admin panel.
      </p>
      <Link to="/dashboard" className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 text-sm">
        ← Back to your tools
      </Link>
    </div>
  )
}

export function RequireTool({ tool, label, children }: { tool: ToolId; label: string; children: React.ReactNode }) {
  const access = useAccess()
  if (access.loading) return <Pending />
  if (!canAccessTool(access, tool)) return <Denied what={label} />
  return <>{children}</>
}

export function RequireAdmin({ children }: { children: React.ReactNode }) {
  const access = useAccess()
  if (access.loading) return <Pending />
  if (!access.isAdmin) return <Denied what="the Admin panel" />
  return <>{children}</>
}
